(() => {
  const configElement = document.getElementById('fr-finish-swatch-config');
  if (!configElement) return;
  const { images, labels } = JSON.parse(configElement.textContent);
  const initialized = new WeakSet();
  let sequence = 0;
  function element(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  function initialize(select) {
    if (initialized.has(select)) return;
    const options = [...select.options].filter(option => images[option.value]);
    if (!options.length) return;
    initialized.add(select);
    const root = element('div', 'fr-finish-swatches');
    const search = element('input');
    search.type = 'search';
    search.placeholder = labels.search;
    search.id = `fr-finish-search-${++sequence}`;
    const searchLabel = element('label', '', labels.search);
    searchLabel.htmlFor = search.id;
    const grid = element('div', 'fr-finish-swatches__grid');
    grid.setAttribute('role', 'group');
    grid.setAttribute('aria-label', labels.browse);
    const empty = element('p', 'fr-finish-swatches__note', labels.empty);
    empty.hidden = true;
    const preview = element('figure', 'fr-finish-swatches__preview');
    preview.hidden = true;
    const previewImage = element('img');
    previewImage.width = 300;
    previewImage.height = 400;
    const caption = element('figcaption');
    caption.setAttribute('aria-live', 'polite');
    preview.append(previewImage, caption);
    const cards = options.map(option => {
      const button = element('button', 'fr-finish-swatches__card');
      button.type = 'button';
      button.disabled = option.disabled || select.disabled;
      button.dataset.finish = option.value;
      button.setAttribute('aria-pressed', 'false');
      const image = element('img');
      image.src = `${images[option.value]}&width=180`;
      image.alt = option.value;
      image.width = 180;
      image.height = 180;
      image.loading = 'lazy';
      button.append(image, element('span', '', option.value));
      if (option.disabled) button.append(element('small', '', labels.unavailable));
      button.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
      grid.append(button);
      return button;
    });
    function update() {
      cards.forEach((card, index) => {
        card.setAttribute('aria-pressed', String(card.dataset.finish === select.value));
        card.disabled = options[index].disabled || select.disabled;
      });
      const url = images[select.value];
      preview.hidden = !url;
      if (url) {
        previewImage.src = `${url}&width=600`;
        previewImage.alt = select.value;
        caption.textContent = `${labels.selected}: ${select.value}`;
      }
    }
    search.addEventListener('input', () => {
      const query = search.value.toLocaleLowerCase().trim();
      cards.forEach(card => card.hidden = !card.dataset.finish.toLocaleLowerCase().includes(query));
      empty.hidden = cards.some(card => !card.hidden);
    });
    select.addEventListener('change', update);
    root.append(preview, searchLabel, search, grid, empty, element('p', 'fr-finish-swatches__note', labels.note));
    select.insertAdjacentElement('afterend', root);
    update();
  }
  function scan() {
    document.querySelectorAll('select[name="properties[Patch finish]"]').forEach(initialize);
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
})();
